// "use client";
// import React, { useEffect } from "react";

// export default function ErrorFallback({ title = "Something went wrong", description = "An unexpected error occurred.", onRetry }) {
//   useEffect(() => {
//     const t = setTimeout(() => {
//       try {
//         // Redirect to home to escape a possibly broken route
//         if (typeof window !== "undefined") {
//           if (window.location.pathname !== "/") {
//             window.location.replace("/");
//           } else {
//             window.location.reload();
//           }
//         }
//       } catch {}
//     }, 100);
//     return () => clearTimeout(t);
//   }, []);

//   return (
//     <div className="min-h-[60vh] flex items-center justify-center px-6">
//       <div className="max-w-xl w-full bg-white shadow-md rounded-lg p-8 text-center">
//         <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-red-100 flex items-center justify-center">
//           <span className="text-3xl">⚠️</span>
//         </div>
//         <h1 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h1>
//         <p className="text-gray-600 mb-2">{description}</p>
//         <p className="text-gray-500">Redirecting to home...</p>
//       </div>
//     </div>
//   );
// }

"use client";
import React from "react";

export default function ErrorFallback({
  title = "Something went wrong",
  description = "An unexpected error occurred.",
  onRetry,
}) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="max-w-xl w-full bg-white shadow-md rounded-lg p-8 text-center">
        <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-red-100 flex items-center justify-center">
          <span className="text-3xl">⚠️</span>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h1>
        <p className="text-gray-600 mb-4">{description}</p>

        {onRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
